export const TOAST_WIDTH_CLASSNAME = 'w-63 sm:w-80';
export const TOAST_SHADOW_CLASSNAME = 'shadow-sm';
export const TOAST_BACKGROUND_CLASSNAME = 'bg-button-secondary-bg-hover';
export const TOAST_ROUNDED_CLASSNAME = 'rounded-sm';

export const TOAST_ICON_SIZE = 20;

export const TOAST_CONTENT_CONTAINER_CLASSNAME =
	'flex flex-col gap-y-sm items-start justify-between typo-t4';

export const TOAST_CONTENT_CONTAINER_STYLE = {
	// This ensures the content remains properly aligned with the icon.
	lineHeight: `${TOAST_ICON_SIZE}px`,
};

export const TOAST_SUB_CONTENT_CLASSNAME = 'typo-b4';
